module.exports = __webpack_public_path__ + "img/logo-bold-dark-beta.6bc87959.jpg";